export default __webpack_public_path__ + "static/media/hra-round.ffae9cd2.svg";